import { MultiSelectOption } from '@/components/atoms/MultiSelect';
import { Role } from '@/shared/types/role';
import { SYSTEM_ROLE_ORDER } from '@/util/systemRoles';

type RoleOption = { label: string; value: string; description?: string; disabled?: boolean };

export const roleSelectOptions = (
  availableRoles: RoleOption[],
  roles: Pick<Role, 'role_id' | 'account_id'>[],
  labels: { system: string; custom: string }
): MultiSelectOption[] => {
  const customRoleIds = new Set(
    roles.filter((role) => !!role.account_id).map((role) => role.role_id)
  );
  const rank = (value: string) => {
    const index = SYSTEM_ROLE_ORDER.indexOf(value);
    return index === -1 ? SYSTEM_ROLE_ORDER.length : index;
  };

  return [...availableRoles]
    .sort((a, b) => rank(a.value) - rank(b.value) || a.label.localeCompare(b.label))
    .map(({ label, value, description, disabled }) => ({
      label,
      value,
      description,
      disabled,
      group: customRoleIds.has(value) ? labels.custom : labels.system,
    }));
};
